export default __webpack_public_path__ + "static/media/bigLogo.4727adae.svg";